<template lang="pug">
  .general-settings
    v-app-bar.white.elavation-0(app light style="box-shadow: 0 2px 4px 0 rgba(0,0,0,.08) !important;")
      v-container(style="max-width:600px")
        v-layout.my-2
          div.mr-2
            v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/yezza-store')") mdi-arrow-left
          div.title.font-weight-bold Store Pages
          v-spacer
          v-btn.mr-2.my-auto(color='accent' filled depressed height=28 @click="clickAddProduct" small)
            v-icon.ml-n1(small) mdi-plus
            | Add
      
    v-container(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        v-layout.my-6(v-if="pages.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption Pages not found or empty
        template(v-else v-for="(page, index) in pages")
          yezza-store-page-item(:key="page.slug" :parentPage.sync="page" @deleted="handleDeleteItem" :company="company" @edited="handleEditItem")

      v-pagination.mt-4(v-if="totalPage >= 2" v-model='page' :length='totalPage' :total-visible="6")

    .modals
      add-yezza-page(v-if="showAddWaFormDialog" :open.sync="showAddWaFormDialog" :company="company" @added="handleAddItem")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import AddYezzaPage from '@/components/dialogs/AddYezzaPage.vue'
import YezzaStorePageItem from '@/components/YezzaStorePageItem.vue'

export default {
  name: 'YezzaStorePages',
  components: { AddYezzaPage, YezzaStorePageItem },
  props: ['company'],
  data: () => ({
    isFetching: false,
    showAddWaFormDialog: false,
    fetchCount: 10,
    page: 1,
    totalPage: 1,
    pages: [],
    totalCount: 0
  }),
  computed: {
    ...mapState('user', ['member'])
  },
  mounted () {
    if (!this.$route.query.page) {
      this.fetchProducts(1)
    } else {
      this.fetchProducts(this.$route.query.page)
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/store/settings/${this.company.slug}/pages/?page=${page}&page_size=${this.fetchCount}&ordering=-id`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.pages = response.data.results
        this.totalCount = response.data.count
        if (this.totalCount % this.fetchCount == 0) {
          this.totalPage = this.totalCount/this.fetchCount
        } else {
          this.totalPage = this.totalCount/this.fetchCount + 1
        }
        this.totalPage = parseInt(this.totalPage)
      }).catch(() => {})
    },
    clickAddProduct () {
      this.$router.push('/admin/yezza-store/pages/add')
      // this.showAddWaFormDialog = true
    },
    handleDeleteItem (item) {
      this.pages = this.pages.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.pages.splice(0, 0, item)
    },
    handleEditItem (item) {
      let editIndex = 0
      this.pages.forEach((page, index) => {
        if (page.id === item.id) {
          editIndex = index
        }
      })
      this.pages = this.pages.filter((x) => x.id !== item.id)
      this.pages.splice(editIndex, 0, item)
    }
  }
}
</script>